export default "__VITE_ASSET__B9qYeT8K__"